export type ProcessPermission = string;

export interface ProcessPermissionMatrixEntry {
  permission: ProcessPermission;
  label: string;
  roles: readonly string[];
}


export const normalizeRoles = (roles: readonly string[] | undefined | null): string[] =>
  Array.from(
    new Set(
      (roles ?? [])
        .map((role) => role.trim().toUpperCase())
        .filter((role) => role.length > 0)
    )
  );

export const hasProcessPermission = (
  roles: readonly string[] | undefined | null,
  permission: ProcessPermission,
  matrix: readonly ProcessPermissionMatrixEntry[]
): boolean => {
  const normalizedRoles = normalizeRoles(roles);
  const allowedRoles = matrix.find((entry) => entry.permission === permission)?.roles ?? [];
  return allowedRoles.some((role) => normalizedRoles.includes(role));
};

export const resolveProcessPermissions = (
  roles: readonly string[] | undefined | null,
  matrix: readonly ProcessPermissionMatrixEntry[]
): Record<ProcessPermission, boolean> =>
  matrix.reduce(
    (acc, entry) => ({
      ...acc,
      [entry.permission]: hasProcessPermission(roles, entry.permission, matrix)
    }),
    {} as Record<ProcessPermission, boolean>
  );
